import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customerLogo: null,
  decorativeImage: null,
  headerText: "Motor Incident Report Form",
  subheaderText: "Tell Us About An Incident",
  submissionSubText: "Thank you for your report. A copy of your completed FNOL will be sent to the relevant contacts.",
};

const customerThemeSlice = createSlice({
  name: "customerTheme",
  initialState,
  reducers: {
    setCustomerThemeData(state, action) {
      const { logo, decorativeImage, header, subheader, submissionSubText } = action.payload;

      // Update logo
      if (logo && logo.trim() !== "") {
        state.customerLogo = `data:image/png;base64,${logo}`;
      } else {
        state.customerLogo = null;
      }

      // Update header icon
      if (decorativeImage && decorativeImage.trim() !== "") {
        state.decorativeImage = `data:image/png;base64,${decorativeImage}`;
      } else {
        state.decorativeImage = null;
      }

      // Update header text
      if (header && header.trim() !== "") {
        state.headerText = header;
      } else {
        state.headerText = "Motor Incident Report Form";
      }

      // Update subheader text
      if (subheader && subheader.trim() !== "") {
        state.subheaderText = subheader;
      } else {
        state.subheaderText = "Tell Us About An Incident";
      }

      // Update submission sub text
      if (submissionSubText && submissionSubText.trim() !== "") {
        state.submissionSubText = submissionSubText;
      } else {
        state.submissionSubText =
          "Thank you for your report. A copy of your completed FNOL will be sent to the relevant contacts.";
      }
    },
    resetCustomerTheme(state) {
      return initialState;
    },
  },
});

export const { setCustomerThemeData, resetCustomerTheme } = customerThemeSlice.actions;

// Selectors
export const selectCustomerLogo = (state) => state.customerTheme.customerLogo;
export const selectDecorativeImage = (state) => state.customerTheme.decorativeImage;
export const selectHeaderText = (state) => state.customerTheme.headerText;
export const selectSubheaderText = (state) => state.customerTheme.subheaderText;
export const selectSubmissionSubText = (state) => state.customerTheme.submissionSubText;

export default customerThemeSlice.reducer;
